import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import Map from "../../components/common/MapComponent/Map";
import { Box, CircularProgress } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function ChargingPartnerMapPage(props: any) {
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [loading, setLoading] = useState(true);

    interface LatLng {
        lat: number;
        lng: number;
    }


    interface InsightData {
        virtualChargingHubsData: []; // Replace 'SomeType' with the actual type for this data
        chargingPartnerPolygons: [];
        businessPolygons: [],
        businessLocations: [];
        diverts: [];
    }

    const [insightData, setInsightData] = useState<InsightData>({
        virtualChargingHubsData: [],
        chargingPartnerPolygons: [],
        businessPolygons: [],
        businessLocations: [],
        diverts: [],
    });
    const [enableButton, setEnableButton] = useState(false);

    async function fetchChargingPartnerMap() {
        let bodyData: { [name: string]: string } = {};
        bodyData["uuid"] = userInfo.uuid;
        bodyData["businessUuid"] = userInfo.businessUuid;
        bodyData["fleetUuid"] = userInfo.fleetUuid;

        try {
            const response = await fetchWithAuth('/charging-partner/map/get', {
                method: 'POST',
                body: JSON.stringify(bodyData),
            });

            if (!response.ok) {
                setLoading(false);
                return;
            }

            const res_json = await response.json();
            res_json.virtualChargingHubList = isNull(res_json.chargingPartnerDwellings);
            setVirtualChargingHubs(res_json);
        } catch (error) {
            console.error('Error fetching charging partner map:', error);
        } finally {
            setLoading(false);
        }
    }

    function isNull(array: any) {
        if (array === null || array === undefined) {
            return [];
        }
        return array;
    }

    function setVirtualChargingHubs(obj: any) {

        let charging_partner_network_map_data = isNull(obj.chargingPartnerDwellings);
        let chargingPartnerPolygons = obj.chargingPartnerPolygons;
        let businessPolygons = obj.businessPolygons;

        setInsightData({
            virtualChargingHubsData: charging_partner_network_map_data,
            chargingPartnerPolygons: chargingPartnerPolygons,
            businessPolygons: businessPolygons,
            businessLocations: isNull(obj.businessDwellings),
            diverts: obj.diverts,
        });

    }

    useEffect(() => {
        fetchChargingPartnerMap();
    }, []);


    if (loading) return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
            <CircularProgress />
        </Box>
    );
    return (

        <Map
            selectedLocationDwelling={[]}
            enableButton={[enableButton, setEnableButton]}
            vehicleMapData={[]}
            partnerLocations={insightData.virtualChargingHubsData}
            chargingPartnerPolygons={insightData.chargingPartnerPolygons}
            businessPolygons={insightData.businessPolygons}
            showButtons={true}
            businessLocations={insightData.businessLocations}
            diverts={insightData.diverts}
        />
    );
}

export default ChargingPartnerMapPage;
